// extracted by mini-css-extract-plugin
export default {"transcribedTotal":"transcribedTotal__H0Gz6k","monthlyOverview":"monthlyOverview__N2Iptf","transcribedOverview":"transcribedOverview__w4vF4e"};